import { ApiErrorTranslationKeys } from '@/lib/api/apiErrorTranslationKeys.ts';

/**
 * Backend error keys specific to financial transactions. Detect these on 400
 * responses with `isKnownBackendErrorKey` to show tailored messages.
 *
 * Values are `TranslationKey` enum member names — see `hasErrorKey` for why the
 * dotted variant (`error.transaction.allocations_exceed_amount`) never matches.
 */
export const FinancialTransactionErrorKeys = {
  /** Sum of allocations exceeds the transaction amount. */
  ALLOCATIONS_EXCEED_AMOUNT: 'TRANSACTION_ALLOCATIONS_EXCEED_AMOUNT',
} as const satisfies Record<string, keyof typeof ApiErrorTranslationKeys>;
